export default function StoryForm({ storyData, onUpdate }) {
  return (
    <div className="story-form">
      <h2>Story Details</h2>
      <div className="form-group">
        <label htmlFor="headline">Headline</label>
        <textarea
          id="headline"
          value={storyData.headline}
          onChange={(e) => onUpdate({ headline: e.target.value })}
          placeholder="Paste headline here..."
          rows={3}
        />
      </div>
      <div className="form-group">
        <label htmlFor="subtitle">Subtitle (Optional)</label>
        <textarea
          id="subtitle"
          value={storyData.subtitle || ''}
          onChange={(e) => onUpdate({ subtitle: e.target.value })}
          placeholder="Optional subtitle text..."
          rows={2}
        />
      </div>
      <div className="form-group">
        <label htmlFor="category">Category</label>
        <input
          id="category"
          type="text"
          value={storyData.category}
          onChange={(e) => onUpdate({ category: e.target.value })}
          placeholder="e.g., Local, News, Sports"
        />
      </div>
      <div className="form-group">
        <label htmlFor="authorName">Author Name</label>
        <input
          id="authorName"
          type="text"
          value={storyData.authorName}
          onChange={(e) => onUpdate({ authorName: e.target.value })}
          placeholder="e.g., Jane Doe"
        />
      </div>
      <div className="form-group">
        <label htmlFor="authorRole">Author Role</label>
        <input
          id="authorRole"
          type="text"
          value={storyData.authorRole}
          onChange={(e) => onUpdate({ authorRole: e.target.value })}
          placeholder="e.g., Staff Writer"
        />
      </div>
      <div className="form-group">
        <label htmlFor="titlePosition">Title Position</label>
        <select
          id="titlePosition"
          value={storyData.titlePosition}
          onChange={(e) => onUpdate({ titlePosition: e.target.value })}
        >
          <option value="top">Top</option>
          <option value="bottom">Bottom</option>
        </select>
      </div>
    </div>
  );
}

